import { Configuration, LogLevel } from '@azure/msal-browser';
import { getConfig } from '@/config/configLoader';

export const getMsalConfig = (): Configuration => {
  const config = getConfig();
  return {
    auth: {
      clientId: config.MSAL_CONFIG_CLIENT_ID,
      authority: `${config.MSAL_CONFIG_AUTHORITY}${config.MSAL_CONFIG_TENANT_ID}`,
      redirectUri: config.MSAL_REDIRECT_URI,
    },
    cache: {
      cacheLocation: 'localStorage',
      storeAuthStateInCookie: false,
    },
    system: {
      loggerOptions: {
        loggerCallback: (level: LogLevel, message: string, containsPii: boolean) => {
          if (containsPii) return;
          switch (level) {
            case LogLevel.Error:   console.error(message); break;
            case LogLevel.Warning: console.warn(message);  break;
            case LogLevel.Info:    console.info(message);  break;
            case LogLevel.Verbose: console.debug(message); break;
          }
        },
      },
    },
  };
};

export const getDefaultScopes = (): string[] => [getConfig().MSAL_CONFIG_SCOPE];
